<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :title="title"
    @close="cancelTimer"
  >
    <div>
      <div>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>订单编号：</th>
              <td colspan="2">
                <strong>{{ formData.orderNo }}</strong>
              </td>
            </tr>
            <tr>
              <th>订单金额：</th>
              <td colspan="2" style="color: red">￥{{ formData.amount }}元</td>
            </tr>
            <tr>
              <th>费用描述：</th>
              <td colspan="2">
                {{ formData.product }}
              </td>
            </tr>
            <tr>
              <th>创建时间：</th>
              <td>
                {{ formatTime(formData.createTime) }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 显示支付操作 -->
        <div class="row">
          <div class="col-sm-12">
            <div class="alert alert-success" role="alert">
              <div style="font-size: 16px">
                <strong
                  >请选择以下2种支付方式进行扫码支付，在提示您支付成功之前，请勿关闭当前窗口</strong
                >
              </div>
              <div style="font-size: 16px">
                <strong><em>（注意：请勿重复支付）</em></strong>
              </div>
            </div>
          </div>
          <div class="col-xs-6 pay-method-box">
            <a href="javascript:void(0)" @click="wxpay" class="pay-method">
              <img :src="wxlogo" alt="微信支付" :style="wxStyle" />
            </a>
          </div>
          <div class="col-xs-6 pay-method-box">
            <a href="javascript:void(0)" @click="alipay" class="pay-method">
              <img
                src="@/assets/alipay.png"
                alt="支付宝支付"
                style="
                  height: 60px;
                  width: 100%;
                  display: block;
                  margin-top: 80px;
                "
              />
            </a>
          </div>
        </div>
      </div>
      <!-- 隐藏支付宝跳转表单 -->
      <div style="display: none" id="ali_submit_div"></div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="cancelTimer" size="mini" type="primary"
        >关 闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { o_fee_type } from "@/utils/enums";
import vueQr from "vue-qr";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      wxQrCodeLoaded: false, //微信二维码是否加载成功
      wxlogo: "",
      isPayed: false, //订单是否支付
      timer: null, //订单支付状态轮询器
      wxStyle: {
        height: "60px",
        width: "100%",
        display: "block",
        marginTop: "80px",
      },
      dialogVisible: false,
      formData: {},
      regInfo: {},
      feeSettingData: {},
      title:'论文报名缴费',
      oType:''
    };
  },
  watch: {
    isPayed: function (newValue, oldValue) {
      if (newValue) {
        //支付成功，清除定时器
        this.cancelTimer();
      }
    },
  },
  created() {
    this.wxlogo = require("@/assets/wechatpay.png");
    // this.getRegInfo();
  },
  destroyed() {
    this.cancelTimer();
  },
  methods: {
    formatTime(time) {
        // time 格式yyyy-MM-dd hh:mm:ss
        if (!time) {
          return "";
        }
        const timestamp = Date.parse(time);
        const date = new Date(timestamp);
        const YY = date.getFullYear();
        const MM =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        const DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        const h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        const minute =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        const second =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return `${YY}年${MM}月${DD}日 ${h}:${minute}:${second}`;
      },
    createTimer() {
      this.timer = setInterval(() => {
        const params = {
          orderId: this.formData.id,
          type:this.oType
        };
        this.$http.post_s(`/student/thesis2/order/detail`, params,{isQs:1}).then((res) => {
          if (res.isPaid) {
            this.isPayed = true;
            this.dialogVisible = false;
            this.$emit('refresh')
            // this.getRegInfo();
          }
        });
      }, 3000);
    },
    cancelTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.dialogVisible = false;
    },

    open(params,title='论文报名缴费',oType) {
      this.formData = params;
      this.dialogVisible = true;
      this.title=title
      this.oType=oType
    },
    wxpay() {
      //发起微信支付
      if (this.wxQrCodeLoaded) {
        return;
      }
      if (!this.timer) {
        this.createTimer();
      }
      const params = {
        orderId: this.formData.id,
        payMethod: "WXPAY",
        type:this.oType
      };
      this.$http.post(`/student/thesis2/getPayInfo`, params,{isQs:1}).then((res) => {
        this.wxlogo = res;
        this.wxQrCodeLoaded = true;
        this.wxStyle = {
          height: "100%",
          width: "100%",
          display: "block",
        };
      });
    },
    async alipay() {
      //发起支付宝支付
      if (!this.timer) {
        this.createTimer();
      }

      const params = {
        orderId: this.formData.id,
        payMethod: "ALIPAY",
        type:this.oType
      };
      this.$http.post(`/student/thesis2/getPayInfo`, params,{isQs:1}).then((res) => {
        let aliSubmitDiv = document.getElementById("ali_submit_div");
        aliSubmitDiv.innerHTML = res;
        let formId = "alipcpayform_" + this.formData.orderNo;
        let formedom = document.getElementById(formId);
        formedom.submit();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mr-30 {
  margin-right: 30px;
}

.mr-80 {
  margin-right: 80px;
}

.font-bold {
  color: #333;
  font-weight: bold;
}

.order {
  border: 1px solid #ddd;
  font-size: 12px;
}

.order-title {
  background: #eaf8ff;
  padding: 12px;
}

.order-info {
  padding: 18px 12px;
}

.price {
  font-size: 18px;
  color: red;
}

.pay {
  margin-top: 12px;

  .pay-title {
    font-size: 14px;
    color: #666;
    font-weight: bold;

    span {
      display: inline-block;
      width: 4px;
      height: 20px;
      margin: 8px 6px 8px 0;
      background-color: #2eb3e5;
    }
  }

  .pay-way {
    padding: 50px;
    border: 1px solid #ddd;
    font-size: 12px;
    margin: 12px 50px 26px 26px;
    cursor: pointer;
    justify-content: center;

    img {
      margin-bottom: 12px;
    }
  }
}

.tooltip {
  text-align: center;
  font-size: 16px;
  color: red;
}
.pay-method-box {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pay-method {
    height: 220px;
    width: 220px;
    display: block;
    border: 1px solid #ccc;
    padding: 0 12px;
    cursor: pointer;
  }
</style>
